// extracted by mini-css-extract-plugin
export default {"modalTalentDetail":"style_modalTalentDetail__uSo+J","videoWrapper":"style_videoWrapper__V4Pdf","contactUser":"style_contactUser__6y2JH"};